import { render, staticRenderFns } from "./editHistory.vue?vue&type=template&id=23e283b0&scoped=true"
import script from "./editHistory.vue?vue&type=script&lang=js"
export * from "./editHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e283b0",
  null
  
)

export default component.exports